import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const CustomTooltip = ({ active, payload }: any) => {
    if (!active || !payload?.length) return null;
    const { name, value } = payload[0].payload;

    return (
        <div className="bg-white border border-gray-200 rounded-lg px-3 py-2 shadow-sm text-sm">
        <p className="font-semibold text-gray-700">{name}</p>
        <p className="text-gray-500">PCI: {value}</p>
        </div>
    );
};

const CustomYTick = ({
    x,
    y,
    payload,
}: {
    x: number;
    y: number;
    payload: any;
    }) => {
    return (
        <text
        x={x - 8}
        y={y}
        textAnchor="end"
        dominantBaseline="middle"
        fontSize={12}
        fill="#4B5563"
        >
        {payload.value}
        </text>
    );
};

export const FunctionalClassBreakdownChart = ({ barData }: { barData: any[] }) => (
    <ResponsiveContainer width="100%" height={220}>
        <BarChart
        data={barData}
        layout="vertical"
        margin={{ top: 4, right: 24, left: 8, bottom: 4 }}
        >
        <CartesianGrid horizontal={false} stroke="#f1f5f9" />
        <XAxis
            type="number"
            domain={[0, 100]}
            ticks={[0, 25, 50, 75, 100]}
            tick={{ fontSize: 12, fill: "#4B5563" }}
            axisLine={false}
            tickLine={false}
        />
        <YAxis
            type="category"
            dataKey="name"
            width={190}
            tick={(props: any) => <CustomYTick {...props} />}
            axisLine={false}
            tickLine={false}
        />
        <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: "rgba(15,23,42,0.03)" }}
        />
        <Bar dataKey="value" radius={[0, 999, 999, 0]} barSize={14}>
            {barData.map((entry) => (
            <Cell key={entry.id} fill={entry.color} />
            ))}
            <LabelList dataKey="value" position="right" fontSize={12} />
        </Bar>
        </BarChart>
    </ResponsiveContainer>
);